import controller from './vd-segcontrol-group.controller'

const SegcontrolGroupComponent = {
  require: {
    ngModelCtrl: 'ngModel',
  },
  template: '<div ng-transclude class="vd-flex"></div>',
  transclude: true,
  controller,
}

export default SegcontrolGroupComponent
